import { LibraryActionTypes, LibraryState } from './libraryTypes';

const INIT_STATE: LibraryState = {
  items: [],
  total: 0,
  page: 1,
  pageSize: 20,
  isLoading: false,
  error: null,
};

const libraryReducer = (state = INIT_STATE, action: any): LibraryState => {
  switch (action.type) {

    case LibraryActionTypes.FETCH_INSIGHTS:
      return { ...state, isLoading: true, error: null };

    case LibraryActionTypes.DELETE_INSIGHT:
      return { ...state, isLoading: true };

    case LibraryActionTypes.SET_PAGE:
      return { ...state, page: action.payload.page };

    case LibraryActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case LibraryActionTypes.FETCH_INSIGHTS:
          return {
            ...state,
            items:     action.payload.data.items,
            total:     action.payload.data.total,
            page:      action.payload.data.page,
            pageSize:  action.payload.data.pageSize,
            isLoading: false,
            error:     null,
          };
        case LibraryActionTypes.DELETE_INSIGHT:
          return {
            ...state,
            items:     state.items.filter(i => i.id !== action.payload.data.id),
            total:     state.total - 1,
            isLoading: false,
          };
        default:
          return state;
      }

    case LibraryActionTypes.API_RESPONSE_ERROR:
      return { ...state, isLoading: false, error: action.payload.error };

    default:
      return state;
  }
};

export default libraryReducer;
